import {
    isFirebaseConfigured,
    fetchCatsMagicPost,
    saveCatsMagicPost,
    sanitizeCatsMagicEpisodeId,
    fetchCatsMagicEpisode,
    saveCatsMagicEpisode,
    listCatsMagicEpisodes,
    deleteCatsMagicEpisode,
    signInCatsMagicAdmin,
    signOutCatsMagicAdmin,
    onCatsMagicAdminChanged
} from './catarot-firebase-api';

declare global {
    interface Window {
        CatarotFirebase?: {
            isConfigured: () => boolean;
            fetchCatsMagicPost: () => Promise<unknown | null>;
            saveCatsMagicPost: (post: unknown) => Promise<void>;
            sanitizeCatsMagicEpisodeId: (raw: string) => string | null;
            fetchCatsMagicEpisode: (slug: string) => Promise<unknown | null>;
            saveCatsMagicEpisode: (slug: string, post: unknown) => Promise<void>;
            deleteCatsMagicEpisode: (slug: string) => Promise<void>;
            listCatsMagicEpisodes: () => Promise<
                Array<{
                    slug: string;
                    updatedAtMs: number;
                    titleKo: string;
                    titleEn: string;
                    titleJa: string;
                    excerptKo: string;
                    excerptEn: string;
                    excerptJa: string;
                    publishedAt: string;
                    imageUrl: string;
                }>
            >;
            signInCatsMagicAdmin: () => Promise<string | null>;
            signOutCatsMagicAdmin: () => Promise<void>;
            onCatsMagicAdminChanged: (callback: (isAdmin: boolean) => void) => () => void;
        };
    }
}

window.CatarotFirebase = {
    isConfigured: isFirebaseConfigured,
    fetchCatsMagicPost,
    saveCatsMagicPost,
    sanitizeCatsMagicEpisodeId,
    fetchCatsMagicEpisode,
    saveCatsMagicEpisode,
    deleteCatsMagicEpisode,
    listCatsMagicEpisodes,
    signInCatsMagicAdmin,
    signOutCatsMagicAdmin,
    onCatsMagicAdminChanged
};
